// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { InvitationModel  } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class RespondentReminderBaseService {
  constructor() { }

  abstract reminderRequest(model: InvitationModel): void;
}
